import { render } from "./SuccessConfirmation.vue?vue&type=template&id=3302eaa4"
import script from "./SuccessConfirmation.vue?vue&type=script&lang=js"
export * from "./SuccessConfirmation.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__